<div class="metrics-tab">
  <div class="search">
    <input class="search_input" disabled="true" pInputText type="text" placeholder=""
      [(ngModel)]="keyword" (keyup)="userSearch()" />

    <button pButton type="button" icon="fa fa-filter" class="search_filter"
      [ngStyle]="chipsArray.length > 0 && { color: SYSTEM_COLORS.$systemGreen }" (click)="op.toggle($event)">
    </button>

    <p-overlayPanel #op>
      <ng-template pTemplate>
        <div class="search-filter">
          <app-table-filter
            [data]="filterData"
            (filterData)="onFilterChange($event)"
          ></app-table-filter>
        </div>
      </ng-template>
    </p-overlayPanel>
  </div>
  <app-overview-card
    [reviewsData]="reviewsData"
    [dailyAvgRatings]="dailyAvgRatings"
    [dailyTotalReviews]="dailyTotalReviews"
    [periodType]="periodType"
    (hide)="hideOverview($event)"
  ></app-overview-card>
</div>
